var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorldOfTanks3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "68px",
    height: "93px",
    viewBox: "0 0 68 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(11.372549%,11.372549%,10.588235%)",
      fillOpacity: 1
    },
    d: "M 60.382812 19.734375 L 54.199219 13.460938 L 47.566406 6.902344 L 20.433594 6.902344 L 13.972656 13.460938 L 7.789062 19.734375 L 27.570312 19.734375 L 27.570312 76.382812 L 34.085938 82.824219 L 40.601562 76.382812 L 40.601562 19.734375 Z M 60.382812 19.734375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(11.372549%,11.372549%,10.588235%)",
      fillOpacity: 1
    },
    d: "M 53.972656 25.863281 L 47.753906 25.863281 L 47.753906 51.140625 L 41.253906 57.558594 L 45.828125 62 L 50.453125 66.488281 L 60.402344 56.65625 L 60.402344 25.863281 Z M 20.421875 51.140625 L 20.421875 25.863281 L 7.769531 25.863281 L 7.769531 56.65625 L 17.722656 66.488281 L 22.34375 62 L 26.917969 57.558594 Z M 20.421875 51.140625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(11.372549%,11.372549%,10.588235%)",
      fillOpacity: 1
    },
    d: "M 19.460938 3.449219 L 3.449219 19.445312 L 3.449219 58.214844 L 34 88.183594 L 64.550781 58.214844 L 64.550781 19.445312 L 48.542969 3.449219 Z M 0.511719 17.515625 L 17.539062 0.511719 L 18.042969 0.00390625 L 49.957031 0.00390625 L 50.460938 0.511719 L 67.488281 17.515625 L 68 18.027344 L 68 59.648438 L 67.484375 60.15625 L 35.207031 91.8125 L 34 92.996094 L 32.792969 91.8125 L 0.519531 60.15625 L 0 59.648438 L 0 18.027344 Z M 0.511719 17.515625 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldOfTanks3);
export default __webpack_public_path__ + "static/media/world-of-tanks-3.b5d89c2e48228c2eea73abb7fd651f50.svg";
export { ForwardRef as ReactComponent };